<template>
  <div class="add-customerName">
    <div class="search">
      <div class="search-left">
        <el-input class="white" v-model="customerName" placeholder="请输入客户名称/简称" />
        <el-button class="btn-blue" @click="searchData">搜索</el-button>
      </div>
      <el-button class="btn-blue" @click="addCustomer">添加客户</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户名称"></el-table-column>
        <el-table-column prop="ordersName" label="客户简称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button  v-if="scope.row.status == 0" type="text" class="btn-text" @click="openCustomerAccount(scope.row.id)"
              >开启</el-button
            >
            <el-button v-else type="text" class="btn-text" @click="closeCustomerAccount(scope.row.id)"
              >关闭</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
    <!-- 新增客户 -->
    <el-dialog title="新增客户" top="35vh" :visible.sync="customerDialog" width="420px">
      <div class="border"></div>
      <p class="error-message" v-show="customerForm.errorMeaasge">{{ customerForm.errorMeaasge }}</p>
      <el-form
        ref="customerForm"
        :rules="customerFormRules"
        :model="customerForm"
        label-width="80px"
      >
        <el-form-item label="客户名称：" prop="name">
          <el-input v-model="customerForm.name" class="white"></el-input>
        </el-form-item>
        <el-form-item label="客户简写：" prop="abbreviation">
          <el-input v-model="customerForm.abbreviation" class="white"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submit('customerForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      customerName: '',
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      customerDialog: false,
      customerForm: {
        errorMeaasge: "",
        name: "",
        abbreviation: ""
      },
      customerFormRules: {
        name: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        abbreviation: [
          { required: true, message: "请输入客户简写", trigger: "blur" }
        ]
      },
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('客户列表')
    this.initCustomerList()
  },
  methods: {
    addCustomer() {
      this.customerDialog = true;
    },
    //获取列表
    initCustomerList() {
      let pageNo = this.currentPage;
      let queryStr = this.customerName;
      projectManage
        .getCustomerList(pageNo, queryStr)
        .then(res => {
          if (res.success) {
            let tableData = [];
            this.pageSize = res.result.pageSize;
            this.total = res.result.totalNum;
            res.result.items.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.customerName = value.name;
              obj.ordersName = value.ordersName;
              obj.status = value.status;
              tableData.push(obj);
            });
            this.tableData = tableData;
          }
        });
    },
    searchData() {
      this.currentPage = 1
      this.initCustomerList();
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initCustomerList();
    },
    closeDialog() {
      this.customerDialog = false;
    },
    /* 新增客户 */
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.name = this.customerForm.name;
          data.ordersName = this.customerForm.abbreviation;
          projectManage.postAddCustomer(data).then(res => {
            if (res.success) {
              this.closeDialog();
              this.customerForm.errorMeaasge = "";
              this.initCustomerList();
            } else {
              this.customerForm.errorMeaasge = res.message;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /* 开启客户 */
    openCustomerAccount(id) {
      projectManage.postOpenCustomerAccount(id).then(res => {
        if (res.success) {
          this.initCustomerList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /* 关闭客户 */
    closeCustomerAccount(id) {
      projectManage.postCloseCustomerAccount(id).then(res => {
        if (res.success) {
          this.initCustomerList();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-customerName {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn-blue {
      margin-left: 16px;
    }
    .search-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .el-table {
      .price-container {
        display: flex;
        color: #666666;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
<style lang="scss">
.add-customerName {
  .table {
    .el-table {
      .el-input {
        width: 80px;
        .el-input__inner {
          height: 24px;
          width: 80px;
          padding-left: 10px;
        }
      }
    }
  }
  .el-dialog {
    .el-form {
      .el-form-item__content {
        height: 32px;
        display: flex;
        align-items: center;
        .el-radio {
          margin-right: 10px;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
